import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PolicyLibraryView, labelForCapability } from "@/components/policy-library/policy-library-view";

export const Route = createFileRoute("/_authenticated/app/policies/")({
  component: PolicyLibraryPage,
  validateSearch: (s) =>
    z
      .object({
        capability: z.string().min(1).max(64).optional(),
      })
      .parse(s),
});

export { labelForCapability };

function PolicyLibraryPage() {
  const { capability } = Route.useSearch();
  return <PolicyLibraryView initialCapability={capability} />;
}
